import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useEffect } from 'react';

export default function Loading() {

    useEffect(() => {

        //if logged in, redirect to user profile selection
        // if (localStorage.getItem('jwt_token')) {
        //   navigate(PATH.userProfileSelectionPath);
        // }
        //redirect sso
        const authEndpoint = process.env.REACT_APP_AUTH_ENDPOINT;
        const clientId = process.env.REACT_APP_CONSUMER_KEY;
        const redirectUri = process.env.REACT_APP_REDIRECT_URL;
        //const responseType = 'code';
    
        const redirectUrl = `${authEndpoint}?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}`;
        window.location.href = redirectUrl;
      }, []);

  return (
    //align center
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress size={'10rem'} color='error'/>
    </Box>
  );
}